import React from 'react';
import { Group } from '../../../primitives/Group/Group.es.js';
import { PaginationPageButton } from '../styled.es.js';

var PaginationButton = function PaginationButton(_ref) {
  var _ref$buttonComponent = _ref.buttonComponent,
      ButtonComponent = _ref$buttonComponent === void 0 ? PaginationPageButton : _ref$buttonComponent,
      buttonSize = _ref.buttonSize,
      shape = _ref.shape,
      isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick,
      page = _ref.page,
      itemType = _ref.itemType,
      children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(Group.Item, null,
    /* @__PURE__ */
    React.createElement(PaginationPageButton, {
      as: ButtonComponent,
      onClick: onClick,
      buttonSize: buttonSize,
      shape: shape,
      isDisabled: isDisabled,
      variant: "subtle",
      page: page,
      itemType: itemType,
      "aria-current": isSelected ? true : void 0
    }, children))
  );
};

export { PaginationButton as default };